import { HomeIcon, TiresIcon, ServicesIcon, FuelIcon, VehiclesIcon, IncidentsIcon, RenewalsIcon, ExpensesIcon, RemindersIcon, ReportsIcon, OffersIcon, VendorsIcon, SettingsIcon, MeterIcon } from "../svgs/index";

export const SidebarData = [
    { name: 'Dashboard', icon: HomeIcon, src: '/dashboard' },
    { name: 'Vehicles', icon: VehiclesIcon, src: '/vehicles', },
    { name: 'Incidents', icon: IncidentsIcon, src: '/incidents' },
    { name: 'Meters', icon: MeterIcon, src: '/meters' },
    { name: 'Renewals', icon: RenewalsIcon, src: '/renewals' },
    { name: 'Services', icon: ServicesIcon, src: '/services' },
    { name: 'Fuels', icon: FuelIcon, src: '/fuels' },
    { name: 'Expenses', icon: ExpensesIcon, src: '/expenses' },
    { name: 'Tires', icon: TiresIcon, src: '/tires' },
    {
        name: 'Reminders',
        icon: RemindersIcon,
        src: '#',
        subItems: [
            { name: 'Service Reminders', src: '/reminders/services' },
            { name: 'Renewal Reminders', src: '/reminders/renewals' },
        ],
    },
    {
        name: 'FSM',
        icon: ServicesIcon,
        src: '#',
        subItems: [
            // { name: 'Crews', src: '#' },
            {
                name: 'Jobs',
                src: '/fsm/jobs',
                // subItems: [
                //     { name: 'Expenses', src: '#' },
                //     { name: 'Notes', src: '#' },
                // ],
            },
            { name: 'Clock', src: '/fsm/clock' },
        ],
    },
    {
        name: 'Reports',
        icon: ReportsIcon,
        src: '#',
        subItems: [
            { name: 'Expense By Vehicles', src: '/reports/expenses/vehicles' },
            { name: 'Expenses By Vendors', src: '/reports/expenses/vendors' },
            { name: 'Expenses by Categories', src: '/reports/expenses/categories' },
        ],
    },
    { name: 'Offers', icon: OffersIcon, src: '/offers' },
    { name: 'Vendors', icon: VendorsIcon, src: '/vendors' },
    {
        name: 'Settings',
        icon: SettingsIcon,
        src: '#',
        subItems: [
            { name: 'Users', src: '/settings/users' },
            { name: 'Notifications', src: '/settings/notifications' },
            { name: ' Preferences', src: '/settings/preferences' },
        ],
    },

];


export const FuelData = [
    {
        time: '2025-07-03T08:30',
        vehicle: 'Blue Cruiser',
        vendor: 'ESSO',
        quantity: 10.0,
        spender: 'John Doe',
        status: 'Submitted',
        odometer: 1000,
        amount: 18.2,
        fuelType: 'Regular',
        note: 'Filled up before road trip',
    },
    {
        time: '2025-07-05T12:45',
        vehicle: 'Silver Bullet',
        vendor: 'Shell',
        quantity: 12.5,
        spender: 'Jane Smith',
        status: 'Accepted',
        odometer: 1050,
        amount: 22.75,
        fuelType: 'Premium',
        note: 'Client meeting travel',
    },
    {
        time: '2025-07-07T15:20',
        vehicle: 'Workhorse',
        vendor: 'Chevron',
        quantity: 15.0,
        spender: 'Mike Johnson',
        status: 'Pending',
        odometer: 1200,
        amount: 27.6,
        fuelType: 'Diesel',
        note: 'Construction site visit',
    },
    {
        time: '2025-07-10T09:15',
        vehicle: 'Executive',
        vendor: 'BP',
        quantity: 8.75,
        spender: 'Sarah Williams',
        status: 'In Progress',
        odometer: 1350,
        amount: 16.8,
        fuelType: 'Mid-grade',
        note: 'Airport pickup',
    },
    {
        time: '2025-07-12T17:30',
        vehicle: 'Adventure',
        vendor: 'Petro Canada',
        quantity: 20.0,
        spender: 'David Brown',
        status: 'Completed',
        odometer: 1480,
        amount: 36.5,
        fuelType: 'Regular',
        note: 'Team offsite event',
    },
];


export const UserData = [
    {
        userId: 'U001',
        firstName: 'John',
        lastName: 'Doe',
        username: 'john.doe',
        email: 'john.doe@example.com',
        role: 'Admin',
        status: 'Active',
        mobile: '+1-202-555-0131',
    },
    {
        userId: 'U002',
        firstName: 'Jane',
        lastName: 'Smith',
        username: 'jane.smith',
        email: 'jane.smith@example.com',
        role: 'User',
        status: 'Pending',
        mobile: '+1-202-555-0174',
    },
    {
        userId: 'U003',
        firstName: 'Mike',
        lastName: 'Johnson',
        username: 'mike.j',
        email: 'mike.johnson@example.com',
        role: 'Manager',
        status: 'Suspended',
        mobile: '+1-202-555-0193',
    },
    {
        userId: 'U004',
        firstName: 'Sarah',
        lastName: 'Williams',
        username: 'sarah.w',
        email: 'sarah.williams@example.com',
        role: 'Editor',
        status: 'Active',
        mobile: '+1-202-555-0122',
    },
    {
        userId: 'U005',
        firstName: 'David',
        lastName: 'Brown',
        username: 'david.b',
        email: 'david.brown@example.com',
        role: 'User',
        status: 'Inactive',
        mobile: '+1-202-555-0168',
    },
];




export const ExpenseData = [
    {
        time: '2025-07-02T10:00',
        vendor: 'Office Depot',
        category: 'Office Supplies',
        currency: 'EUR',
        amount: 95.50,
        spender: 'John Doe',
        vehicle: 'Blue Cruiser',
        job: 'Admin Setup',
        status: 'Submitted',
        paymentMethod: 'Credit Card',
    },
    {
        time: '2025-07-04T14:30',
        vendor: 'Uber',
        category: 'Travel',
        currency: 'EUR',
        amount: 23.75,
        spender: 'Jane Smith',
        vehicle: 'Silver Bullet',
        job: 'Client Visit',
        status: 'Accepted',
        paymentMethod: 'Cash',
    },
    {
        time: '2025-07-06T08:45',
        vendor: 'Starbucks',
        category: 'Meals & Entertainment',
        currency: 'EUR',
        amount: 12.90,
        spender: 'Mike Johnson',
        vehicle: 'Workhorse',
        job: 'Morning Meeting',
        status: 'Pending',
        paymentMethod: 'Company Card',
    },
    {
        time: '2025-07-08T16:00',
        vendor: 'Hertz',
        category: 'Car Rental',
        currency: 'EUR',
        amount: 180.00,
        spender: 'Sarah Williams',
        vehicle: 'Executive',
        job: 'Field Survey',
        status: 'In Progress',
        paymentMethod: 'Credit Card',
    },
    {
        time: '2025-07-11T11:15',
        vendor: 'Amazon Business',
        category: 'Hardware',
        currency: 'EUR',
        amount: 249.99,
        spender: 'David Brown',
        vehicle: 'Adventure',
        job: 'IT Equipment',
        status: 'Completed',
        paymentMethod: 'Bank Transfer',
    },
];




export const ServicesData = [
    {
        id: 'SRV-001',
        serviceTime: '2025-07-03T08:30',
        vehicle: 'CRV',
        vendor: 'AutoCare Plus',
        fuelType: 'Oil Change',
        name: 'Standard Service',
        odometer: 5000,
        status: 'Completed',
    },
    {
        id: 'SRV-002',
        serviceTime: '2025-07-05T12:45',
        vehicle: 'Civic',
        vendor: 'QuickLube Pro',
        type: 'Tire Rotation',
        name: 'Premium Service',
        odometer: 7500,
        status: 'In Progress',
    },
    {
        id: 'SRV-003',
        serviceTime: '2025-07-07T15:20',
        vehicle: 'Hilux',
        vendor: 'Truck Masters',
        type: 'Brake Inspection',
        name: 'Safety Check',
        odometer: 12000,
        status: 'Scheduled',
    },
    {
        id: 'SRV-004',
        serviceTime: '2025-07-10T09:15',
        vehicle: 'Accord',
        vendor: 'Elite Auto',
        type: 'Battery Replacement',
        name: 'Electrical Service',
        odometer: 30000,
        status: 'Pending',
    },
    {
        id: 'SRV-005',
        serviceTime: '2025-07-12T17:30',
        vehicle: 'Fortuner',
        vendor: 'Offroad Specialists',
        type: 'Suspension Check',
        name: '4x4 Service',
        odometer: 25000,
        status: 'Completed',
    },
    {
        id: 'SRV-006',
        serviceTime: '2025-07-15T10:00',
        vehicle: 'CRV',
        vendor: 'GreenTech Auto',
        type: 'AC Service',
        name: 'Seasonal Maintenance',
        odometer: 18000,
        status: 'Approved',
    },
    {
        id: 'SRV-007',
        serviceTime: '2025-07-18T14:30',
        vehicle: 'Civic',
        vendor: 'Precision Tune',
        type: 'Transmission Fluid',
        name: 'Fluid Change',
        odometer: 42000,
        status: 'Completed',
    },
    {
        id: 'SRV-008',
        serviceTime: '2025-07-20T11:45',
        vehicle: 'Hilux',
        vendor: 'Heavy Duty Motors',
        type: 'Engine Diagnostic',
        name: 'Check Engine Light',
        odometer: 35000,
        status: 'Diagnosing',
    },
    {
        id: 'SRV-009',
        serviceTime: '2025-07-22T16:15',
        vehicle: 'Accord',
        vendor: 'Luxury Auto Spa',
        type: 'Detailing',
        name: 'Full Interior Clean',
        odometer: 22000,
        status: 'Scheduled',
    },
    {
        id: 'SRV-010',
        serviceTime: '2025-07-25T09:30',
        vehicle: 'Fortuner',
        vendor: 'All-Terrain Auto',
        type: 'Wheel Alignment',
        name: 'Suspension Package',
        odometer: 28000,
        status: 'In Progress',
    },
];

export const MeterData = [
    {
        time: '2025-07-03T08:30',
        meterId: 'MET-001',
        vehicle: 'CRV',
        type: 'electric',
        value: 1250,
        status: 'active'
    },
    {
        time: '2025-07-05T12:45',
        meterId: 'MET-002',
        vehicle: 'Civic',
        type: 'water',
        value: 8450,
        status: 'active'
    },
    {
        time: '2025-07-07T15:20',
        meterId: 'MET-003',
        vehicle: 'Hilux',
        type: 'gas',
        value: 3200,
        status: 'maintenance'
    },
    {
        time: '2025-07-10T09:15',
        meterId: 'MET-004',
        vehicle: 'Accord',
        type: 'electric',
        value: 1875,
        status: 'active'
    },
    {
        time: '2025-07-12T17:30',
        meterId: 'MET-005',
        vehicle: 'Fortuner',
        type: 'water',
        value: 9200,
        status: 'calibration'
    },

];


export const IncidentData = [
    {
        time: '2025-07-03T08:30',
        incidentId: 'INC-001',
        vehicle: 'CRV',
        category: 'Accident',
        causer: 'John Doe',
        location: 'Main Street',
        address: '123 Main St, Cityville',
        note: 'Minor rear-end collision at traffic light. No injuries reported.',
        status: 'reported'
    },
    {
        time: '2025-07-05T12:45',
        incidentId: 'INC-002',
        vehicle: 'Civic',
        category: 'Breakdown',
        causer: 'Jane Smith',
        location: 'Highway 401',
        address: 'KM 205, Highway 401',
        note: 'Engine overheated and vehicle stopped working. Required tow truck assistance.',
        status: 'investigating'
    },
    {
        time: '2025-07-07T15:20',
        incidentId: 'INC-003',
        vehicle: 'Hilux',
        category: 'Theft',
        causer: 'Unknown',
        location: 'Construction Site',
        address: '45 Industrial Blvd, Worktown',
        note: 'Tools stolen from truck bed overnight while parked at construction site.',
        status: 'investigating'
    },
    {
        time: '2025-07-10T09:15',
        incidentId: 'INC-004',
        vehicle: 'Accord',
        category: 'Vandalism',
        causer: 'Unknown',
        location: 'Parking Lot',
        address: '78 Shopping Mall Dr, Retail City',
        note: 'Key marks along passenger side door and broken side mirror.',
        status: 'reported'
    },
    {
        time: '2025-07-12T17:30',
        incidentId: 'INC-005',
        vehicle: 'Fortuner',
        category: 'Accident',
        causer: 'Mike Johnson',
        location: 'Intersection',
        address: 'Corner of 5th Ave and Maple St',
        note: 'T-bone collision with another vehicle. Police report filed. Moderate damage to front left side.',
        status: 'resolved'
    },
    {
        time: '2025-07-15T11:00',
        incidentId: 'INC-006',
        vehicle: 'CRV',
        category: 'Breakdown',
        causer: 'Sarah Williams',
        location: 'Country Road',
        address: 'Rural Route 5, Countryside',
        note: 'Flat tire with no spare available. Required roadside assistance.',
        status: 'closed'
    },
    {
        time: '2025-07-18T14:45',
        incidentId: 'INC-007',
        vehicle: 'Civic',
        category: 'Accident',
        causer: 'David Brown',
        location: 'Parking Garage',
        address: '90 Downtown Tower, Business District',
        note: 'Scraped side panel while parking. Minor paint damage.',
        status: 'resolved'
    },
    {
        time: '2025-07-20T08:10',
        incidentId: 'INC-008',
        vehicle: 'Hilux',
        category: 'Vandalism',
        causer: 'Unknown',
        location: 'Job Site',
        address: '22 Construction Lane, Buildertown',
        note: 'Windows smashed overnight while parked at remote job site.',
        status: 'reported'
    },
    {
        time: '2025-07-22T16:30',
        incidentId: 'INC-009',
        vehicle: 'Accord',
        category: 'Theft',
        causer: 'Unknown',
        location: 'Hotel Parking',
        address: 'Grand Hotel, 1 Resort Ave',
        note: 'Luggage stolen from trunk while attending conference.',
        status: 'investigating'
    },
    {
        time: '2025-07-25T13:15',
        incidentId: 'INC-010',
        vehicle: 'Fortuner',
        category: 'Breakdown',
        causer: 'John Doe',
        location: 'Mountain Pass',
        address: 'Alpine Route 77',
        note: 'Transmission failure during mountain trip. Vehicle required towing to nearest service center.',
        status: 'closed'
    }
];


export const TireData = [
    {
        tireId: 'TIR-001',
        time: '2025-01-15T10:00',
        vehicle: 'Blue Cruiser',
        brand: 'Michelin',
        model: 'Primacy 4',
        vendor: 'TireMart',
        tin: 'DOT ABCD 1234',
        size: '225/65R17',
        season: 'summer',
        rim: 'On RIM',
        position: 'Front-Left',
        status: 'assigned',
        note: 'Installed for summer road trip'
    },
    {
        tireId: 'TIR-002',
        time: '2025-02-20T14:30',
        vehicle: 'Silver Bullet',
        brand: 'Bridgestone',
        model: 'Turanza T005',
        vendor: 'AutoZone',
        tin: 'DOT EFGH 5678',
        size: '215/55R16',
        season: 'all_season',
        rim: 'Off RIM',
        position: 'Front-Right',
        status: 'assigned',
        note: 'Standard replacement'
    },
    {
        tireId: 'TIR-003',
        time: '2024-11-10T09:15',
        vehicle: 'Workhorse',
        brand: 'Goodyear',
        model: 'Wrangler AT',
        vendor: 'TireWorld',
        tin: 'DOT IJKL 9012',
        size: '265/70R16',
        season: 'all_season',
        rIM: 'On RIM',
        position: 'Rear-Left',
        status: 'assigned',
        note: 'Off-road use'
    },
    {
        tireId: 'TIR-004',
        time: '2025-03-05T11:45',
        vehicle: 'Executive',
        brand: 'Continental',
        model: 'PremiumContact 6',
        vendor: 'TireMart',
        tin: 'DOT MNOP 3456',
        size: '235/45R18',
        season: 'summer',
        rim: 'On RIM',
        position: 'Rear-Right',
        status: 'in_storage',
        note: 'Stored for seasonal use'
    },
    {
        tireId: 'TIR-005',
        time: '2024-10-25T13:20',
        vehicle: 'Adventure',
        brand: 'Pirelli',
        model: 'Scorpion ATR',
        vendor: 'AutoZone',
        tin: 'DOT QRST 7890',
        size: '265/60R18',
        season: 'all_season',
        rim: 'Off RIM',
        position: 'Front-Left',
        status: 'assigned',
        note: 'Heavy-duty terrain use'
    },
];



export const VehicleData = [
    {
        vehicleId: 'VH-001',
        checkbox: false,
        name: 'Blue Cruiser',
        licensePlate: 'ABC123',
        year: 2023,
        make: 'Honda',
        model: 'CR-V',
        vehicleType: 'SUV',
        status: 'active',
        action: null
    },
    {
        vehicleId: 'VH-002',
        checkbox: false,
        name: 'Silver Bullet',
        licensePlate: 'XYZ789',
        year: 2022,
        make: 'Honda',
        model: 'Civic',
        vehicleType: 'Sedan',
        status: 'active',
        action: null
    },
    {
        vehicleId: 'VH-003',
        checkbox: false,
        name: 'Workhorse',
        licensePlate: 'TRK001',
        year: 2021,
        make: 'Toyota',
        model: 'Hilux',
        vehicleType: 'Truck',
        status: 'active',
        action: null
    },
    {
        vehicleId: 'VH-004',
        checkbox: false,
        name: 'Executive',
        licensePlate: 'LUX202',
        year: 2023,
        make: 'Honda',
        model: 'Accord',
        vehicleType: 'Sedan',
        status: 'active',
        action: null
    },
    {
        vehicleId: 'VH-005',
        checkbox: false,
        name: 'Adventure',
        licensePlate: 'SUV456',
        year: 2022,
        make: 'Toyota',
        model: 'Fortuner',
        vehicleType: 'SUV',
        status: 'maintenance',
        action: null
    },
];


export const VendorData = [
    {
        vendorId: 'VD-001',
        name: 'AutoCare Plus',
        location: 'Downtown Garage',
        address: '123 Main Street',
        city: 'New York',
        state: 'NY',
        country: 'US',
        postalCode: '10001',
        status: 'active'
    },
    {
        vendorId: 'VD-002',
        name: 'QuickLube Pro',
        location: 'Westside Service Center',
        address: '456 Oak Avenue',
        city: 'Los Angeles',
        state: 'CA',
        country: 'US',
        postalCode: '90015',
        status: 'active'
    },
    {
        vendorId: 'VD-003',
        name: 'Truck Masters',
        location: 'Industrial Zone',
        address: '789 Diesel Lane',
        city: 'Chicago',
        state: 'IL',
        country: 'US',
        postalCode: '60609',
        status: 'active'
    },
    {
        vendorId: 'VD-004',
        name: 'Elite Auto',
        location: 'Financial District',
        address: '101 Luxury Blvd',
        city: 'San Francisco',
        state: 'CA',
        country: 'US',
        postalCode: '94104',
        status: 'active'
    },
    {
        vendorId: 'VD-005',
        name: 'Offroad Specialists',
        location: 'Mountain View',
        address: '202 Trail Drive',
        city: 'Denver',
        state: 'CO',
        country: 'US',
        postalCode: '80202',
        status: 'pending'
    },
    {
        vendorId: 'VD-006',
        name: 'GreenTech Auto',
        location: 'Eco Park',
        address: '303 Green Way',
        city: 'Seattle',
        state: 'WA',
        country: 'US',
        postalCode: '98101',
        status: 'active'
    },
    {
        vendorId: 'VD-007',
        name: 'Precision Tune',
        location: 'Midtown',
        address: '404 Gear Street',
        city: 'Houston',
        state: 'TX',
        country: 'US',
        postalCode: '77002',
        status: 'inactive'
    },
    {
        vendorId: 'VD-008',
        name: 'Heavy Duty Motors',
        location: 'Port Area',
        address: '505 Haul Road',
        city: 'Miami',
        state: 'FL',
        country: 'US',
        postalCode: '33101',
        status: 'active'
    },
    {
        vendorId: 'VD-009',
        name: 'Luxury Auto Spa',
        location: 'Uptown',
        address: '606 Shine Avenue',
        city: 'Dallas',
        state: 'TX',
        country: 'US',
        postalCode: '75201',
        status: 'active'
    },
    {
        vendorId: 'VD-010',
        name: 'All-Terrain Auto',
        location: 'Adventure District',
        address: '707 Offroad Way',
        city: 'Phoenix',
        state: 'AZ',
        country: 'US',
        postalCode: '85001',
        status: 'suspended'
    },
    {
        vendorId: 'VD-011',
        name: 'Metro Auto Services',
        location: 'City Center',
        address: '808 Urban Street',
        city: 'Philadelphia',
        state: 'PA',
        country: 'US',
        postalCode: '19102',
        status: 'active'
    },
    {
        vendorId: 'VD-012',
        name: 'Performance Motors',
        location: 'Speed Zone',
        address: '909 Race Track Road',
        city: 'Atlanta',
        state: 'GA',
        country: 'US',
        postalCode: '30301',
        status: 'active'
    },
    {
        vendorId: 'VD-013',
        name: 'Family Auto Care',
        location: 'Suburban Plaza',
        address: '1010 Safe Drive',
        city: 'Boston',
        state: 'MA',
        country: 'US',
        postalCode: '02108',
        status: 'pending'
    },
    {
        vendorId: 'VD-014',
        name: 'Eco Auto Solutions',
        location: 'Green District',
        address: '1111 Eco Lane',
        city: 'San Diego',
        state: 'CA',
        country: 'US',
        postalCode: '92101',
        status: 'active'
    },
    {
        vendorId: 'VD-015',
        name: '24/7 Roadside Assistance',
        location: 'Highway Hub',
        address: '1212 Emergency Way',
        city: 'Las Vegas',
        state: 'NV',
        country: 'US',
        postalCode: '89101',
        status: 'active'
    }
];



export const RenewalData = [
    {
        renewalId: 'RNW-001',
        renewalTime: '2023-05-15T09:30:00',
        vehicle: 'VH-001 (Blue Cruiser)',
        lineageId: 'LN-001',
        parentId: 'PRNT-001',
        vendors: ['Goodyear', 'Michelin'],
        type: 'Tire Replacement',
        name: 'Quarterly Tire Maintenance',
        remindTime: '2023-05-10T09:00:00',
        dueTime: '2023-05-20T17:00:00',
        status: 'completed',
        subRows: []
    },
    {
        renewalId: 'RNW-002',
        renewalTime: '2023-06-01T14:15:00',
        vehicle: 'VH-002 (Silver Bullet)',
        lineageId: 'LN-002',
        parentId: 'PRNT-002',
        vendors: ['Castrol', 'Mobil'],
        type: 'Oil Change',
        name: 'Synthetic Oil Replacement',
        remindTime: '2023-05-28T09:00:00',
        dueTime: '2023-06-05T17:00:00',
        status: 'completed',
        subRows: [
            {
                renewalId: 'RNW-001',
                renewalTime: '2023-05-15T09:30:00',
                vehicle: 'VH-001 (Blue Cruiser)',
                lineageId: 'LN-001',
                parentId: 'PRNT-001',
                vendors: ['Goodyear', 'Michelin'],
                type: 'Tire Replacement',
                name: 'Quarterly Tire Maintenance',
                remindTime: '2023-05-10T09:00:00',
                dueTime: '2023-05-20T17:00:00',
                status: 'completed'
            },
            {
                renewalId: 'RNW-002',
                renewalTime: '2023-05-15T09:30:00',
                vehicle: 'VH-001 (Blue Cruiser)',
                lineageId: 'LN-001',
                parentId: 'PRNT-001',
                vendors: ['Goodyear', 'Michelin'],
                type: 'Tire Replacement',
                name: 'Quarterly Tire Maintenance',
                remindTime: '2023-05-10T09:00:00',
                dueTime: '2023-05-20T17:00:00',
                status: 'completed'
            },
            {
                renewalId: 'RNW-003',
                renewalTime: '2023-05-15T09:30:00',
                vehicle: 'VH-001 (Blue Cruiser)',
                lineageId: 'LN-001',
                parentId: 'PRNT-001',
                vendors: ['Goodyear', 'Michelin'],
                type: 'Tire Replacement',
                name: 'Quarterly Tire Maintenance',
                remindTime: '2023-05-10T09:00:00',
                dueTime: '2023-05-20T17:00:00',
                status: 'completed'
            }
        ]
    },
    {
        renewalId: 'RNW-003',
        renewalTime: '2023-06-10T11:00:00',
        vehicle: 'VH-003 (Workhorse)',
        lineageId: 'LN-003',
        parentId: 'PRNT-003',
        vendors: ['Bosch', 'Denso'],
        type: 'Battery Replacement',
        name: 'Annual Battery Check',
        remindTime: '2023-06-05T09:00:00',
        dueTime: '2023-06-15T17:00:00',
        status: 'pending',
        subRows: []
    },
    {
        renewalId: 'RNW-004',
        renewalTime: '2023-07-05T10:30:00',
        vehicle: 'VH-004 (Executive)',
        lineageId: 'LN-004',
        parentId: 'PRNT-004',
        vendors: ['Bridgestone'],
        type: 'Tire Rotation',
        name: 'Bi-annual Tire Service',
        remindTime: '2023-06-28T09:00:00',
        dueTime: '2023-07-10T17:00:00',
        status: 'scheduled',
        subRows: []
    },
    {
        renewalId: 'RNW-005',
        renewalTime: '2023-07-15T13:45:00',
        vehicle: 'VH-005 (Adventure)',
        lineageId: 'LN-005',
        parentId: 'PRNT-005',
        vendors: ['Shell', 'Chevron'],
        type: 'Fuel System',
        name: 'Fuel Filter Replacement',
        remindTime: '2023-07-10T09:00:00',
        dueTime: '2023-07-20T17:00:00',
        status: 'scheduled',
        subRows: [
            {
                renewalId: 'RNW-001',
                renewalTime: '2023-05-15T09:30:00',
                vehicle: 'VH-001 (Blue Cruiser)',
                lineageId: 'LN-001',
                parentId: 'PRNT-001',
                vendors: ['Goodyear', 'Michelin'],
                type: 'Tire Replacement',
                name: 'Quarterly Tire Maintenance',
                remindTime: '2023-05-10T09:00:00',
                dueTime: '2023-05-20T17:00:00',
                status: 'completed'
            },
            {
                renewalId: 'RNW-002',
                renewalTime: '2023-05-15T09:30:00',
                vehicle: 'VH-001 (Blue Cruiser)',
                lineageId: 'LN-001',
                parentId: 'PRNT-001',
                vendors: ['Goodyear', 'Michelin'],
                type: 'Tire Replacement',
                name: 'Quarterly Tire Maintenance',
                remindTime: '2023-05-10T09:00:00',
                dueTime: '2023-05-20T17:00:00',
                status: 'completed'
            },
            {
                renewalId: 'RNW-003',
                renewalTime: '2023-05-15T09:30:00',
                vehicle: 'VH-001 (Blue Cruiser)',
                lineageId: 'LN-001',
                parentId: 'PRNT-001',
                vendors: ['Goodyear', 'Michelin'],
                type: 'Tire Replacement',
                name: 'Quarterly Tire Maintenance',
                remindTime: '2023-05-10T09:00:00',
                dueTime: '2023-05-20T17:00:00',
                status: 'completed'
            }
        ]
    },
];



export const countryCodes = [
    { code: '+93', name: 'AF' },
    { code: '+355', name: 'AL' },
    { code: '+213', name: 'DZ' },
    { code: '+1-684', name: 'AS' },
    { code: '+376', name: 'AD' },
    { code: '+244', name: 'AO' },
    { code: '+1-264', name: 'AI' },
    { code: '+672', name: 'AQ' },
    { code: '+1-268', name: 'AG' },
    { code: '+54', name: 'AR' },
    { code: '+374', name: 'AM' },
    { code: '+297', name: 'AW' },
    { code: '+61', name: 'AU' },
    { code: '+43', name: 'AT' },
    { code: '+994', name: 'AZ' },
    { code: '+1-242', name: 'BS' },
    { code: '+973', name: 'BH' },
    { code: '+880', name: 'BD' },
    { code: '+1-246', name: 'BB' },
    { code: '+375', name: 'BY' },
    { code: '+32', name: 'BE' },
    { code: '+501', name: 'BZ' },
    { code: '+229', name: 'BJ' },
    { code: '+1-441', name: 'BM' },
    { code: '+975', name: 'BT' },
    { code: '+591', name: 'BO' },
    { code: '+387', name: 'BA' },
    { code: '+267', name: 'BW' },
    { code: '+55', name: 'BR' },
    { code: '+673', name: 'BN' },
    { code: '+359', name: 'BG' },
    { code: '+226', name: 'BF' },
    { code: '+257', name: 'BI' },
    { code: '+855', name: 'KH' },
    { code: '+237', name: 'CM' },
    { code: '+1', name: 'CA' },
    { code: '+238', name: 'CV' },
    { code: '+236', name: 'CF' },
    { code: '+235', name: 'TD' },
    { code: '+56', name: 'CL' },
    { code: '+86', name: 'CN' },
    { code: '+57', name: 'CO' },
    { code: '+269', name: 'KM' },
    { code: '+243', name: 'CD' },
    { code: '+242', name: 'CG' },
    { code: '+506', name: 'CR' },
    { code: '+225', name: 'CI' },
    { code: '+385', name: 'HR' },
    { code: '+53', name: 'CU' },
    { code: '+357', name: 'CY' },
    { code: '+420', name: 'CZ' },
    { code: '+45', name: 'DK' },
    { code: '+253', name: 'DJ' },
    { code: '+1-767', name: 'DM' },
    { code: '+1-809', name: 'DO' },
    { code: '+593', name: 'EC' },
    { code: '+20', name: 'EG' },
    { code: '+503', name: 'SV' },
    { code: '+240', name: 'GQ' },
    { code: '+291', name: 'ER' },
    { code: '+372', name: 'EE' },
    { code: '+251', name: 'ET' },
    { code: '+679', name: 'FJ' },
    { code: '+358', name: 'FI' },
    { code: '+33', name: 'FR' },
    { code: '+241', name: 'GA' },
    { code: '+220', name: 'GM' },
    { code: '+995', name: 'GE' },
    { code: '+49', name: 'DE' },
    { code: '+233', name: 'GH' },
    { code: '+30', name: 'GR' },
    { code: '+1-473', name: 'GD' },
    { code: '+502', name: 'GT' },
    { code: '+224', name: 'GN' },
    { code: '+245', name: 'GW' },
    { code: '+592', name: 'GY' },
    { code: '+509', name: 'HT' },
    { code: '+504', name: 'HN' },
    { code: '+852', name: 'HK' },
    { code: '+36', name: 'HU' },
    { code: '+354', name: 'IS' },
    { code: '+91', name: 'IN' },
    { code: '+62', name: 'ID' },
    { code: '+98', name: 'IR' },
    { code: '+964', name: 'IQ' },
    { code: '+353', name: 'IE' },
    { code: '+972', name: 'IL' },
    { code: '+39', name: 'IT' },
    { code: '+1-876', name: 'JM' },
    { code: '+81', name: 'JP' },
    { code: '+962', name: 'JO' },
    { code: '+7', name: 'KZ' },
    { code: '+254', name: 'KE' },
    { code: '+686', name: 'KI' },
    { code: '+82', name: 'KR' },
    { code: '+965', name: 'KW' },
    { code: '+996', name: 'KG' },
    { code: '+856', name: 'LA' },
    { code: '+371', name: 'LV' },
    { code: '+961', name: 'LB' },
    { code: '+266', name: 'LS' },
    { code: '+231', name: 'LR' },
    { code: '+218', name: 'LY' },
    { code: '+423', name: 'LI' },
    { code: '+370', name: 'LT' },
    { code: '+352', name: 'LU' },
    { code: '+853', name: 'MO' },
    { code: '+389', name: 'MK' },
    { code: '+261', name: 'MG' },
    { code: '+265', name: 'MW' },
    { code: '+60', name: 'MY' },
    { code: '+960', name: 'MV' },
    { code: '+223', name: 'ML' },
    { code: '+356', name: 'MT' },
    { code: '+692', name: 'MH' },
    { code: '+222', name: 'MR' },
    { code: '+230', name: 'MU' },
    { code: '+52', name: 'MX' },
    { code: '+691', name: 'FM' },
    { code: '+373', name: 'MD' },
    { code: '+377', name: 'MC' },
    { code: '+976', name: 'MN' },
    { code: '+382', name: 'ME' },
    { code: '+212', name: 'MA' },
    { code: '+258', name: 'MZ' },
    { code: '+95', name: 'MM' },
    { code: '+264', name: 'NA' },
    { code: '+674', name: 'NR' },
    { code: '+977', name: 'NP' },
    { code: '+31', name: 'NL' },
    { code: '+64', name: 'NZ' },
    { code: '+505', name: 'NI' },
    { code: '+227', name: 'NE' },
    { code: '+234', name: 'NG' },
    { code: '+47', name: 'NO' },
    { code: '+968', name: 'OM' },
    { code: '+92', name: 'PK' },
    { code: '+680', name: 'PW' },
    { code: '+507', name: 'PA' },
    { code: '+675', name: 'PG' },
    { code: '+595', name: 'PY' },
    { code: '+51', name: 'PE' },
    { code: '+63', name: 'PH' },
    { code: '+48', name: 'PL' },
    { code: '+351', name: 'PT' },
    { code: '+974', name: 'QA' },
    { code: '+40', name: 'RO' },
    { code: '+7', name: 'RU' },
    { code: '+250', name: 'RW' },
    { code: '+1-869', name: 'KN' },
    { code: '+1-758', name: 'LC' },
    { code: '+1-784', name: 'VC' },
    { code: '+685', name: 'WS' },
    { code: '+378', name: 'SM' },
    { code: '+239', name: 'ST' },
    { code: '+966', name: 'SA' },
    { code: '+221', name: 'SN' },
    { code: '+381', name: 'RS' },
    { code: '+248', name: 'SC' },
    { code: '+232', name: 'SL' },
    { code: '+65', name: 'SG' },
    { code: '+421', name: 'SK' },
    { code: '+386', name: 'SI' },
    { code: '+677', name: 'SB' },
    { code: '+252', name: 'SO' },
    { code: '+27', name: 'ZA' },
    { code: '+34', name: 'ES' },
    { code: '+94', name: 'LK' },
    { code: '+249', name: 'SD' },
    { code: '+597', name: 'SR' },
    { code: '+268', name: 'SZ' },
    { code: '+46', name: 'SE' },
    { code: '+41', name: 'CH' },
    { code: '+963', name: 'SY' },
    { code: '+886', name: 'TW' },
    { code: '+992', name: 'TJ' },
    { code: '+255', name: 'TZ' },
    { code: '+66', name: 'TH' },
    { code: '+670', name: 'TL' },
    { code: '+228', name: 'TG' },
    { code: '+676', name: 'TO' },
    { code: '+1-868', name: 'TT' },
    { code: '+216', name: 'TN' },
    { code: '+90', name: 'TR' },
    { code: '+993', name: 'TM' },
    { code: '+688', name: 'TV' },
    { code: '+256', name: 'UG' },
    { code: '+380', name: 'UA' },
    { code: '+971', name: 'AE' },
    { code: '+44', name: 'GB' },
    { code: '+1', name: 'US' },
    { code: '+598', name: 'UY' },
    { code: '+998', name: 'UZ' },
    { code: '+678', name: 'VU' },
    { code: '+379', name: 'VA' },
    { code: '+58', name: 'VE' },
    { code: '+84', name: 'VN' },
    { code: '+967', name: 'YE' },
    { code: '+260', name: 'ZM' },
    { code: '+263', name: 'ZW' }
];

